module.exports = __webpack_public_path__ + "media/next_game_start_2.406b25d2.mp3";